export default function (context) {
    let data = context.getters['form/data'];
    if (!data||context.state.loading||context.state.items.length) return;
    context.commit('loading', true);
    context.commit('tab', 'list');
    axios({
        method: 'get',
        url: '/tourclient/client/all' + data,
        requestId: 'clientSelect'
    }).then(({data}) => {
        let error = '';
        if (!data) {
            error = 'Не удалось загрузить справочник: Кассы';
        } else if (data.ResultQueryInfo && data.ResultQueryInfo.UserMessages) {
            error = data.ResultQueryInfo.UserMessages;
        }
        if (error) {
            window.app.$notify.error({
                title: 'Ошибка',
                message: error,
            });
        }
        context.commit('items', data);
    }).catch(e => {
        context.commit('items');
        context.dispatch('error', e, {root: true});
    });
}